import { render, staticRenderFns } from "./Disaster.vue?vue&type=template&id=77ef49fb&scoped=true"
import script from "./Disaster.vue?vue&type=script&lang=js"
export * from "./Disaster.vue?vue&type=script&lang=js"
import style0 from "./Disaster.vue?vue&type=style&index=0&id=77ef49fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef49fb",
  null
  
)

export default component.exports